/** Shared top→bottom reveal for portal tabs (iOS-like soft drop-in). */

export const revealEase = [0.22, 1, 0.36, 1];

export const pageVariants = {
  initial: { opacity: 0, y: -14 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 10 },
};

export const pageTransition = {
  duration: 0.34,
  ease: revealEase,
};

/** Parent: stagger children from top to bottom. */
export const revealContainerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.055,
      delayChildren: 0.04,
    },
  },
};

/** Soft section / panel / card item. */
export const revealItemVariants = {
  hidden: { opacity: 0, y: -18, filter: 'blur(2px)' },
  show: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: { duration: 0.42, ease: revealEase },
  },
};

/** Table / list rows — slightly snappier. */
export const revealRowVariants = {
  hidden: { opacity: 0, y: -16 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.34, ease: revealEase },
  },
};

/** Users tab: richer cascade (used with per-index delay). */
export function usersRowTransition(index) {
  return {
    duration: 0.4,
    delay: Math.min(index, 16) * 0.048,
    ease: revealEase,
  };
}

export function usersRowInitial(index) {
  return {
    opacity: 0,
    y: -22 - Math.min(index, 8) * 1.2,
    scale: 0.985,
  };
}

export const usersRowAnimate = {
  opacity: 1,
  y: 0,
  scale: 1,
};

/** Index-based delay for maps that don't use stagger parent. */
export function revealDelay(index, cap = 14, step = 0.048) {
  return Math.min(index, cap) * step;
}

export function revealItemTransition(index, options = {}) {
  const { duration = 0.38, cap = 14, step = 0.05, delayBase = 0.02 } = options;
  return {
    duration,
    delay: delayBase + revealDelay(index, cap, step),
    ease: revealEase,
  };
}
